import { render, staticRenderFns } from "./products.vue?vue&type=template&id=98ed5dde&scoped=true"
import script from "./products.js?vue&type=script&lang=js&external"
export * from "./products.js?vue&type=script&lang=js&external"
import style0 from "./products.vue?vue&type=style&index=0&id=98ed5dde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98ed5dde",
  null
  
)

export default component.exports